import { ExportFileTypeEnum } from 'app/models';

export class ExportFileTypeModel {
    public static ExportFileTypes: Array<any> = [
        { name: 'CSV', value: ExportFileTypeEnum.CSV },
        { name: 'Excel', value: ExportFileTypeEnum.Excel },
        { name: 'PDF', value: ExportFileTypeEnum.PDF }
    ];
}
